var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rate-star"},[_c('table',[_c('tr',_vm._l((5),function(num,index){return _c('td',[_c('a',{staticClass:"rate-off rate-off2",class:_vm.selected[index]?'rate-on rate-on2':'',on:{"click":function($event){return _vm.handleRate(index)}}})])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }